export default "__VITE_ASSET__55ee782b__"